/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CurrentUserDetailOrganizationDetails
 */
export interface CurrentUserDetailOrganizationDetails {
    /**
     * 
     * @type {number}
     * @memberof CurrentUserDetailOrganizationDetails
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDetailOrganizationDetails
     */
    name: string;
}

/**
 * Check if a given object implements the CurrentUserDetailOrganizationDetails interface.
 */
export function instanceOfCurrentUserDetailOrganizationDetails(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function CurrentUserDetailOrganizationDetailsFromJSON(json: any): CurrentUserDetailOrganizationDetails {
    return CurrentUserDetailOrganizationDetailsFromJSONTyped(json, false);
}

export function CurrentUserDetailOrganizationDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CurrentUserDetailOrganizationDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function CurrentUserDetailOrganizationDetailsToJSON(value?: CurrentUserDetailOrganizationDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

